import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';
const API_BASE_URL = isProduction ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;

// Downloads the review dossier PDF of one client (sources, coverage,
// indicators, themes to verify, recorded work).
export const downloadReviewDossier = async (customerId, token) => {
    const res = await axios.get(`${API_BASE_URL}/content/customers/${encodeURIComponent(customerId)}/dossier.pdf`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `review-dossier-${String(customerId).replace(/[^A-Za-z0-9_-]/g, '')}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
